
import worker from "!!../../node_modules/worker-loader/dist/runtime/inline.js";

export default function Worker_fn() {
  return worker("(function(){self.onmessage=e=>{let s=e.data;setInterval((()=>{s--,self.postMessage(s),s<1&&close()}),1e3)}})();\n//# sourceMappingURL=timer.worker.52affba4.worker.js.map", "Worker", undefined, __webpack_public_path__ + "js/timer.worker.52affba4.worker.js");
}
